import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=0ae8b994"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports